// src/components/LandingPage/Footer.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

// Import your support components
import { FAQ, PrivacyPolicy, TermsOfService } from './support';

const FooterWrapper = styled.footer`
  background: ${({ theme }) => theme.cardBackground};
  color: ${({ theme }) => theme.text};
  padding: 4rem 4rem 2rem;
  font-size: 0.9rem;
  border-top: 1px solid ${({ theme }) => `${theme.text}15`};
  margin-top: 5rem;

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 3rem 2rem;
  margin-bottom: 2rem;
`;

const Section = styled.div`
  text-align: left;

  h4 {
    font-weight: 700;
    margin-bottom: 1.2rem;
    font-size: 1rem;
    color: ${({ theme }) => theme.text};
    letter-spacing: -0.01em;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 0.8rem;

      a, button {
        color: ${({ theme }) => `${theme.text}88`};
        text-decoration: none;
        font-weight: 500;
        font-size: 0.95rem;
        transition: all 0.3s ease;
        background: none;
        border: none;
        cursor: pointer;
        font-family: inherit;
        padding: 0;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;

        &:hover {
          color: #58a6ff;
          transform: translateX(2px);
        }
      }
    }
  }
`;

const BottomBar = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${({ theme }) => `${theme.text}15`};
  text-align: center;
  color: ${({ theme }) => `${theme.text}66`};
  font-size: 0.85rem;
  font-weight: 500;
`;

const Footer = () => {
  const [visibleDialog, setVisibleDialog] = useState(null);

  const closeDialog = () => setVisibleDialog(null);

  const dialogFooter = (
    <Button label="Close" icon="pi pi-times" onClick={closeDialog} className="p-button-text" />
  );

  return (
    <FooterWrapper>
      <FooterContainer>
        <Section>
          <h4>Product</h4>
          <ul>
            <li><a href="#features">Features</a></li>
            <li><a href="#templates">Templates</a></li>
            <li><a href="/purchase">Pricing</a></li>
          </ul>
        </Section>

        <Section>
          <h4>Resources</h4>
          <ul>
            <li><a href="/login">Sign In</a></li>
            <li><a href="/onboarding/choose-profile">Get Started</a></li>
            <li><button onClick={() => setVisibleDialog('faq')}>Help & Support</button></li>
          </ul>
        </Section>

        <Section>
          <h4>Legal</h4>
          <ul>
            <li><button onClick={() => setVisibleDialog('privacy')}>Privacy Policy</button></li>
            <li><button onClick={() => setVisibleDialog('terms')}>Terms of Service</button></li>
            <li><a href="mailto:support@portify.app">Contact Support</a></li>
          </ul>
        </Section>

        <Section>
          <h4>Follow</h4>
          <ul>
            <li><a href="https://twitter.com/portify" target="_blank" rel="noopener noreferrer">Twitter</a></li>
            <li><a href="https://linkedin.com/company/portify" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            <li><a href="https://github.com/portify" target="_blank" rel="noopener noreferrer">GitHub</a></li>
          </ul>
        </Section>
      </FooterContainer>

      <BottomBar>
        &copy; {new Date().getFullYear()} Portify. All rights reserved.
      </BottomBar>

      <Dialog
        header="Frequently Asked Questions"
        visible={visibleDialog === 'faq'}
        style={{ width: '40vw' }}
        modal
        onHide={closeDialog}
        footer={dialogFooter}
      >
        <FAQ />
      </Dialog>

      <Dialog
        header="Privacy Policy"
        visible={visibleDialog === 'privacy'}
        style={{ width: '40vw' }}
        modal
        onHide={closeDialog}
        footer={dialogFooter}
      >
        <PrivacyPolicy />
      </Dialog>

      <Dialog
        header="Terms of Service"
        visible={visibleDialog === 'terms'}
        style={{ width: '40vw' }}
        modal
        onHide={closeDialog}
        footer={dialogFooter}
      >
        <TermsOfService />
      </Dialog>
    </FooterWrapper>
  );
};

export default Footer;
